import { render, staticRenderFns } from "./HumanCapitalWageAverageReport.vue?vue&type=template&id=4b008f30&scoped=true&"
import script from "./HumanCapitalWageAverageReport.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalWageAverageReport.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalWageAverageReport.vue?vue&type=style&index=0&id=4b008f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b008f30",
  null
  
)

export default component.exports